// extracted by mini-css-extract-plugin
export default {"ErrorLogo":"Error_ErrorLogo__snkQL","ErrorMessage":"Error_ErrorMessage__QY-9r"};